module.exports = __webpack_public_path__ + "img/sm.1896d72b.png";